import { useState } from "react";
import { useAuth } from "../../../../../context/AuthContext";
import { useAlert } from "../../../../../context/AlertContext";
import Table from "../../../../../components/Table";
import SearchFilter from "../../../../../components/SearchFilter";
import CardDisplayComponent from "../../../../../components/CardDisplayComponent";

export default function DetailTab() {
  const { user } = useAuth();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([
    {
      Com_Code: user.Com_Code,
      DocDes_Code: "01",
      DocDes_Month: 1,
      DocDes_Year: 2023,
      DocDes_Running: 861,
      JobType: { Job_Type_Name: "PM" },
      Prefix_Name: "BQQ"
    },
    {
      Com_Code: user.Com_Code,
      DocDes_Code: "02",
      DocDes_Month: 2,
      DocDes_Year: 2023,
      DocDes_Running: 1089,
      JobType: { Job_Type_Name: "PM" },
      Prefix_Name: "DO"
    },
    {
      Com_Code: user.Com_Code,
      DocDes_Code: "03",
      DocDes_Month: 3,
      DocDes_Year: 2023,
      DocDes_Running: 1220,
      JobType: { Job_Type_Name: "PM" },
      Prefix_Name: "PE"
    },
    {
      Com_Code: user.Com_Code,
      DocDes_Code: "04",
      DocDes_Month: 4,
      DocDes_Year: 2023,
      DocDes_Running: 1044,
      JobType: { Job_Type_Name: "PM" },
      Prefix_Name: "SPF"
    }
  ]);
  const [searchValue, setSearchValue] = useState([]);
  const searchInput = [
    { name: "Com_Code", label: "รหัสบริษัท", minKeywordLength: 1 },
    { name: "JobType.Job_Type_Name", label: "ประเภทงาน", minKeywordLength: 1 }
  ];
  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row.rowIndex,
      sortable: true,
      width: "110px"
    },
    {
      name: "รหัสบริษัท",
      selector: (row) => row.Com_Code,
      sortable: true,
      grow: 1.5
    },
    {
      name: "ประเภทงาน",
      selector: (row) => row.JobType.Job_Type_Name,
      grow: 2
    },
    { name: "รหัสย่อ", selector: (row) => row.DocDes_Code },
    { name: "ตัวย่อหน้าเอกสาร", selector: (row) => row.Prefix_Name },
    { name: "ปี / คศ.", selector: (row) => row.DocDes_Year },
    { name: "เดือน", selector: (row) => row.DocDes_Month },
    { name: "เลขที่รันนิ่ง", selector: (row) => row.DocDes_Running }
  ];

  return (
    <>
      <CardDisplayComponent
        body={{
          element: (
            <SearchFilter
              data={data}
              inputField={searchInput}
              fieldClassName={{ actionButton: "w-auto py-2" }}
              searchCallback={(search) => setSearchValue(search)}
            />
          )
        }}
      />

      <CardDisplayComponent
        header={{ title: { text: "รายละเอียดเลขที่เอกสาร" } }}
        body={{
          element: (
            <Table
              data={data}
              column={columns}
              searchFilter={searchValue}
              pending={loading}
              pagination
            />
          )
        }}
      />
    </>
  );
}
